module.exports = __webpack_public_path__ + "img/grend_4.8849c694.jpg";